<ng-container *ngFor="let barFilter of barFilters">
  <ng-container *ngIf="isCheckboxFilterTypes(barFilter)">
    <ng-container *ngTemplateOutlet="checkboxType; context: { filter: barFilter }"></ng-container>
  </ng-container>
  <ng-container *ngIf="isRadioFilter(barFilter)">
    <ng-container *ngTemplateOutlet="radioType; context: { filter: barFilter }"></ng-container>
  </ng-container>
  <ng-container *ngIf="isExclusiveOfferFilter(barFilter)">
    <ng-container *ngTemplateOutlet="exclusiveOfferType; context: { filter: barFilter }">
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #exclusiveOfferType let-filter='filter'>
  <ng-container *ngIf="showExclusiveOfferFilter">
    <app-filter-bar-tag
      [class]="'exclusive'"
      [style.order]="filter.order"
      [class.item-active]="pickedMemberRatesOnly"
      [class.is-multiple]="isMultipleSelection(filter.type)"
      [isActive]="pickedMemberRatesOnly"
      [icon]="exclusiveIconTag(filter)"
      [label]="exclusiveLabel(filter)"
      [isMultipleSelection]="isMultipleSelection(filter.type)"
      (clickEvent)="exclusiveOfferFilterEvent.emit()">
    </app-filter-bar-tag>
  </ng-container>
</ng-template>

<ng-template #checkboxType let-filter='filter'>
  <app-filter-bar-tag
    [style.order]="filter.order"
    [class.item-active]="checkedCheckbox(filter)"
    [class.is-multiple]="isMultipleSelection(filter.type)"
    [isActive]="checkedCheckbox(filter)"
    [icon]="getIconTag(filter)"
    [label]="getCheckboxLabel(filter)"
    [isMultipleSelection]="isMultipleSelection(filter.type)"
    (clickEvent)="checkboxTrigger(filter)">
  </app-filter-bar-tag>
</ng-template>

<ng-template #radioType let-filter='filter'>
  <ng-container [ngSwitch]="filter.type">
    <ng-container *ngSwitchCase="hotelFilterTypes.PromotionalRates">
      <app-filter-bar-tag
        [style.order]="filter.order"
        [class.item-active]="pickedTotalDiscountPercentage"
        [class.is-multiple]="isMultipleSelection(filter.type)"
        [isActive]="pickedTotalDiscountPercentage"
        [icon]="getIconTag(filter)"
        [label]="getDiscountPercentageLabel(filter)"
        [isMultipleSelection]="isMultipleSelection(filter.type)"
        (clickEvent)="radioTrigger(filter)">
      </app-filter-bar-tag>
    </ng-container>
  </ng-container>
</ng-template>
